/**
 * authorMedia - template media the author can "send" (pure).
 *
 * ┌──────────────────────────────────────────────────────────────────────┐
 * │  >>> EDIT HERE <<<  Replace the placeholder URLs below with your own    │
 * │  hosted media. Photos appear inline in the chat as the author's pics;   │
 * │  the call videos are used as the mock video-call stream.                │
 * │                                                                         │
 * │  You can point these at:                                                │
 * │   - files in /public (e.g. '/media/author/01.jpg')                      │
 * │   - a CDN (e.g. 'https://cdn.example.com/author/01.jpg')                │
 * │   - an HLS playlist for the call (e.g. 'https://.../stream.m3u8')        │
 * └──────────────────────────────────────────────────────────────────────┘
 */

/** Inline photos the author sends during the scripted chat. */
export const AUTHOR_PHOTOS = [
  // TODO: replace with your real photo URLs.
  'https://vizos.pages.dev/img/1.jpeg',
  'https://vizos.pages.dev/img/2.jpeg',
  'https://vizos.pages.dev/img/3.jpeg',
  'https://vizos.pages.dev/img/4.jpeg',
  'https://vizos.pages.dev/img/5.png',
  'https://vizos.pages.dev/img/6.jpeg',
  'https://vizos.pages.dev/img/7.png',
  'https://vizos.pages.dev/img/8.png',
  'https://vizos.pages.dev/img/9.webp',
];

/**
 * Portrait videos used for the mock video call. Provide mp4 or HLS (.m3u8).
 * The first reachable one is used; leave empty to fall back to a poster only.
 */
export const AUTHOR_CALL_VIDEOS = [
  // TODO: replace with your real portrait call video(s).
  'https://vizos.pages.dev/videos/490.mp4',
  'https://vizos.pages.dev/videos/498.mp4',
  'https://vizos.pages.dev/videos/492.mp4',
  'https://vizos.pages.dev/videos/504.mp4',
  'https://vizos.pages.dev/videos/505.mp4',
  'https://vizos.pages.dev/videos/511.mp4',
  'https://vizos.pages.dev/videos/509.mp4',
];

/**
 * Poster/preloader shown while the call is "connecting" and before the video
 * stream is ready. Replace with your own image if desired.
 */
export const CALL_PRELOADER = 'https://picsum.photos/seed/vizos-call/720/1280';

const sample = (arr) => arr[Math.floor(Math.random() * arr.length)];

/** A random author photo as a chat media descriptor. */
export function randomAuthorPhoto() {
  if (!AUTHOR_PHOTOS.length) return null;
  return { kind: 'photo', url: sample(AUTHOR_PHOTOS) };
}

/** A call video URL, or null if none configured. */
export function randomCallVideo() {
  return AUTHOR_CALL_VIDEOS.length ? sample(AUTHOR_CALL_VIDEOS) : null;
}
